import { ConflictError } from "./conflict-error";

// Thrown when a write would leave an article stocked outside a `storage` warehouse zone —
// assigning it to a location in a staging, consolidation, shipping or receiving zone, moving a
// location that already holds articles into such a zone, or retyping a zone away from `storage`
// while its locations still hold articles. A location with no zone at all counts as outside, too.
//
// The rule exists because a picking round is one zone's share of an order: `upsertSuborders`
// derives a round per zone an order's articles are stocked in, so stock parked outside a storage
// zone still produces rounds nobody staffs a shelf for, and stock on a zoneless location produces
// no round at all and can never be picked.
//
// 409: the payload names locations that exist and the caller may write, but the zone they sit in
// has moved — or the screen offered them before it knew which zone was which. Both clients keep
// non-storage locations out of the picker, so reaching here means this guard is the last one
// standing.
export class NonStorageWarehouseZoneError extends ConflictError {
	constructor() {
		super("stock.non_storage_warehouse_zone");
		this.name = "NonStorageWarehouseZoneError";
	}
}
